'use client'

import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import '@/app/ui/evk-loader.css';

export default function EvkLoader() {
    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-900/60 backdrop-blur-sm overflow-hidden">

            {/* Foguete passando pelo centro */}
            <div className="absolute animate-rocket-pass">
                <RocketLaunchIcon
                    className="text-white drop-shadow-[0_0_15px_rgba(255,255,255,0.5)]"
                    sx={{ fontSize: 70 }}
                />
            </div>

            {/* Bolinhas surgindo sincronizadas */}
            <div className="flex gap-3 animate-dots-sync">
                <span className="h-5 w-5 animate-bounce rounded-full bg-yellow-300 shadow-lg [animation-delay:-0.3s]"></span>
                <span className="h-5 w-5 animate-bounce rounded-full bg-orange-500 shadow-lg [animation-delay:-0.15s]"></span>
                <span className="h-5 w-5 animate-bounce rounded-full bg-red-500 shadow-lg"></span>
            </div>

        </div>
    )
}